/* __next_internal_client_entry_do_not_use__ default auto */ import { useLayoutEffect } from "react";
import scrollToElement from "@/utils/theme/scrollToElement";
export default function Controller(param) {
    let { category } = param;
    useLayoutEffect(()=>{
        scrollToElement(category, 10, 'documentCategoriesHolder', true);
    }, []);
    return null;
}
